<template lang='pug'>
  v-card
    v-card-title
      .display-2 Bienvenido a TENDER Empresas
      v-spacer
      v-icon(aria-label="Close" @click="$emit('close')")
        | mdi-close
    v-divider
    v-card-text.body-1.text-center
      v-row
        v-col(cols="12" md="12")
          v-layout
          .display-1
            |Este es el comienzo de algo realmente especial!
        v-col(cols="12")
          v-row(no-gutters="")
            v-col(v-for="(section, i) in perks1" :key="i" cols="12")
              v-list-item(three-line="")
                v-list-item-content
                  v-list-item-title.font-weight-light.mb-4.mt-3
                    v-icon(:large="$vuetify.breakpoint.mdAndUp" :color="section.iconColor" v-text="section.icon")
                    |  {{section.title}}
                  v-list-item-subtitle(v-text="section.text")
            <!--v-col(v-for="(section, i) in perks2" :key="i" cols="12" md="6")-->
              <!--v-list-item(three-line="")-->
                <!--v-list-item-icon.mr-4.mt-5.mt-md-4-->
                  <!--v-icon(:large="$vuetify.breakpoint.mdAndUp" :color="section.iconColor" v-text="section.icon")-->
                <!--v-list-item-content-->
                  <!--v-list-item-title.font-weight-light.mb-4.mt-3(v-text="section.title")-->
                  <!--v-list-item-subtitle(v-text="section.text")-->
          v-row()
            v-col
              v-btn(@click="$emit('close')" shaped color="primary")  Continuar
</template>

<script>
  export default {
    name: 'DashboardFormsWizard',

    data: () => ({
      perks1: [
        {
          icon: 'mdi-chart-line',
          iconColor: 'primary',
          title: 'Crece',
          text: ' Accede a todas tus facturas, inventarios, compras , ordenes, reportes y vuelve tu negocio mas productivo, tender te brinda herramientas de prediccion inteligentes para que tomes mejores desiciones.',
        },
        {
          icon: 'mdi-clock-fast',
          iconColor: 'secondary',
          title: 'Rápido y Simple',
          text: 'En pocos pasos podrás tener tu tienda virtual, empezarás a conectar con mas clientes y aumentar tus ventas. Sin costos adicionales o comisión  por venta!',
        },
        {
          icon: 'mdi-axis-arrow',
          iconColor: 'cyan',
          title: 'Flexible',
          text: 'Te brindamos herramientas para que tengas total control de tu negocio si tienes un punto físico de venta, y todo desde un mismo lugar',
        },
      ],
      perks2: [
        {
          icon: 'mdi-chart-timeline-variant',
          iconColor: 'primary',
          title: 'Marketing',
          text: 'We\'ve created the marketing campaign of the website. It was a very interesting collaboration.',
        },
        {
          icon: 'mdi-code-tags',
          iconColor: 'secondary',
          title: 'Fully Coded in HTML5',
          text: 'We\'ve developed the website with HTML5 and CSS3. The client has access to the code using GitHub.',
        },
        {
          icon: 'mdi-account-multiple',
          iconColor: 'cyan',
          title: 'Built Audience',
          text: 'There is also a Fully Customizable CMS Admin Dashboard for this product.',
        },
      ],
    }),

    computed: {

    },

    methods: {

    },
  }
</script>

<style lang="sass">

</style>
